// src/pages/Impressum.js

import { Container, Typography } from '@mui/material';
import React from 'react';

const Impressum = () => (
  <Container sx={{ paddingTop: '20px', paddingBottom: '20px' }}>
    <Typography variant="body1">
      Europäisches Jugendparlament Österreich
      Schönbrunner Straße 32/10
      1050 Wien Austria

      ZVR: 760986885
      Email: info@eyp.at

      What is EYP

      The European Youth Parliament is carried by students in a voluntary capacity and has no political mandate. All activities in Austria are done within the EuropaClubs initiative (www.europaclubs.at).

      The European Youth Parliament Austria is a national committee (NC) of the European Youth Parliament on the international level. The Schwarzkopf Foundation is the international umbrella organisation of the European Youth Parliament.

      The organisation’s aim is to facilitate Austrian’s participation at the European Youth Parliament. Furthermore, the understanding of democracy, political participation and political education of young people is facilitated. The organisation is non-partisan, non-confessional and non-governmental.

      The Board and Advisory Board are listed in the Team section.

      Our statutes can be found here.
    </Typography>
  </Container>
);

export default Impressum;
